import { render } from "./copClients.vue?vue&type=template&id=2eb4d5e9"
import script from "./copClients.vue?vue&type=script&lang=js"
export * from "./copClients.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/garbage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__